__webpack_require__.p = "/vikinglotto/";